export class SubticketStatus {
  public Id: number;
  public Code: string;
  public Name: string;
  public ActionName: string;
  public Color: string;
}
